import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2wtd67bx4w: FaireBrandEntity = {
  token: "b_2wtd67bx4w",
  type: "brand",
  name: "2 Fly Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/de3795f0112f4cc1d535a1978fec83fa63ce9b8455435bf8fd54be7a878ec8ac.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/aeb3273bb92fee89925cf26a8905fa726e2ff1d28d02ba8e962129f90458ad37.png",
  logoUrl:
    "https://cdn.faire.com/fastly/de3795f0112f4cc1d535a1978fec83fa63ce9b8455435bf8fd54be7a878ec8ac.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/aeb3273bb92fee89925cf26a8905fa726e2ff1d28d02ba8e962129f90458ad37.png",
  location: "Dublin, TX, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 442,
  isTopShop: true,
  isInsider: true,
  description:
    '2 FLY CO "that\'s an odd name." Well, this is our second clothing brand and we hope it flies... come get a little Western. a little Weird. a little of everything. Original designs -- hand drawn -- & crafted to bring you a  line that customers will want to keep for generations... not just toss away with the next trends. [women.kids.home] we are all inclusive [XS -3X]  and all in. COME JOIN THE FAM & Stay Fly! \n\n\nPOLICIES:\nMSRP: You are required to AT LEAST double your wholesale price for 30 DAYS before discounting. PLEASE NOTE by purchasing these products you agree to sell at MSRP online and IN STORE. We ENCOURAGE you to charge MORE than double but charging any less in the 30 day time frame will be an automatic termination of your account.\n\nReturns have a 30% RESTOCKING FEE & return shipping costs will be paid by customer - MUST be approved prior to shipping item(s) back to warehouse.\n\nStock will NOT be held for exchanges. 30% RESTOCKING FEE + all additional shipping charges paid for by customer. MUST be approved prior to sending item(s) back to warehouse.\n\nALL MISSING ITEMS CLAIMS MUST BE PLACED WITHIN 7 DAYS OF RECEIVING YOUR ORDER. ALL claims submitted after the 7 days will be declined. Please double and triple check your order before submitting a claim for missing items.\n\nALL damage claims will need to have a photo attached for review. ALL CLAIMS MUST BE SUBMITTED WITHIN 7 DAYS OF RECEIVING THE ORDER\n\nWe issue STORE CREDIT only.',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:45.802Z",
    importedBy: "entity-db-cli",
  },
};
